import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface SmileIconProps {
  color?: string;
  size?: number;
}

export default function SmileIcon({ color = '#6600CC', size = 16 }: SmileIconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 20 21" fill="none">
      <Path 
        d="M10.418 17.75C14.5604 17.75 17.918 14.3916 17.918 10.25C17.918 6.10757 14.5604 2.75 10.418 2.75C6.27554 2.75 2.91797 6.10757 2.91797 10.25C2.91797 14.3916 6.27554 17.75 10.418 17.75Z" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <Path 
        d="M8.01562 12.1577C8.60022 12.9182 9.46047 13.3925 10.4156 13.3925C11.3708 13.3925 12.231 12.9182 12.8156 12.1577" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <Path 
        d="M7.72461 7.75444V7.71148M7.68667 7.58398C7.58334 7.58398 7.49917 7.66815 7.50001 7.77148C7.50001 7.87482 7.58417 7.95898 7.68751 7.95898C7.79084 7.95898 7.87501 7.87482 7.87501 7.77148C7.87501 7.66732 7.79084 7.58398 7.68667 7.58398Z" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <Path 
        d="M13.1102 7.75444V7.71148M13.1046 7.58398C13.0013 7.58398 12.9171 7.66815 12.918 7.77148C12.918 7.87482 13.0021 7.95898 13.1055 7.95898C13.2088 7.95898 13.293 7.87482 13.293 7.77148C13.293 7.66732 13.2088 7.58398 13.1046 7.58398Z" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </Svg>
  );
}
